import { getOwnUin, getSaasToken, getSid, getUin } from '../cookies';

// 神策上报注意： 如果有一个 属性是undefined / null 则 上报会失败。
export const reportBeforeRedirectModal = (
  reportType: 'Open' | 'Success' | 'Failed',
  status: '' | '3s_Success' | 'ManualRedirect' | 'BlockRedirectFailure' = '',
) => {
  window?.sensors?.track?.('PopuptoTencent', {
    BusinessType: 'trtc',
    BusinessUin: getUin(),
    ReportType: reportType,
    Status: status,
  });
};
const REPORTUIN = 'report_Uin';

export type LoginProcessReportType =
  | 'loginHasQueryParam'
  | 'loginGetTokenFormSassStart'
  | 'loginGetTokenFormSassEnd'
  | 'loginGetTokenFormSassSuccess'
  | 'loginGetTokenFormSassFailed'
  | 'loginGetTokenFormSassFailedHasCookie'
  | 'loginGetTokenFormSassFailedNoCookie'
  | 'loginGetTokenFormSassFailedNoCookieGotoLogin'
  | 'loginCommonMcStart'
  | 'loginCommonMcFailed'
  | 'loginCommonMcsuccess'
  | 'loginCommonMcFailedGotoLogin'
  | 'loginRequestCheckLoginStart'
  | 'loginRequestCheckLoginSuccess'
  | 'loginRequestCheckLoginFailedGotoLogin'
  | 'loginGetAccountInfoFailedGotoLogin'
  | 'loginSuccess'
  | 'gotoLoginByErrorCode'
  | 'logoutByNavClick'
  | 'gotoLoginFunc';

export const reportLoginProcess = (
  reportType: LoginProcessReportType,
  exterData?: string[],
) => {
  const cookieUin = getUin();
  const cookieOwnerUin = getOwnUin();
  const cookieToken = getSaasToken();
  const cookieSid = getSid();

  cookieUin && sessionStorage.setItem(REPORTUIN, cookieUin);
  const storageUin = sessionStorage.getItem(REPORTUIN);
  const reportUin = cookieUin || storageUin;

  window?.sensors?.track?.('LoginProcess', {
    BusinessType: 'trtc',
    BusinessUin: String(reportUin),
    ReportType: reportType,
    cookieUin: String(cookieUin),
    storageUin: String(storageUin),
    reportUin: String(reportUin),
    cookieOwnerUin: String(cookieOwnerUin),
    cookieToken: String(cookieToken)?.slice?.(0, 3),
    cookieSid: String(cookieSid),
    exterData: exterData?.join?.(',') ?? '',
  });
};

const reportStringArr: string[] = [];

export const createLoginReport = (eventName: LoginProcessReportType) => {
  reportStringArr.push(eventName);
  reportLoginProcess(eventName, reportStringArr);
};

export const reportMenuClick = (
  reportType: 'ConsoleMenuType' | 'ConsoleMenuItem',
  value:
    | 'Demo'
    | 'Docs'
    | 'WhatsApp'
    | 'Telegram'
    | 'FAQ'
    | 'Ticket'
    | 'Message',
) => {
  const cookieUin = getUin();
  window?.sensors?.track?.('ConsoleMenu', {
    BusinessType: 'trtc',
    BusinessUin: String(cookieUin),
    ReportType: reportType,
    value,
  });
};

export const reportLeftMenuClick = (reportType: string) => {
  const cookieUin = getUin();
  window?.sensors?.track?.('ConsoleLeftMenuType', {
    BusinessType: 'trtc',
    BusinessUin: String(cookieUin),
    ReportType: reportType,
  });
};
